import React from 'react'

import { Link } from 'react-router-dom'
import { Tooltip } from 'react-tippy'

import withErrorBoundaryReturnNull from '../../../../components/hocs/withErrorBoundaryReturnNull'
import Insight from '../../../../components/renderPropComponents/Insight'
import CompanyLogo from '../../../../components/ui/CompanyLogo/index'
import searches from '../../../../utils/routing/searches'
import CompanyLink from './CompanyLink'
import JobTags from './JobTags'

const JobPostingListItem = ({
  isFirstPost,
  index,
  jobPosting,
  onSave,
  onSelectJobTitle,
  isLastPost,
}) => {
  const {
    company_name,
    title,
    thumbnail,
    related_links,
    location,
    detected_extensions,
  } = jobPosting

  return (
    <div className="list-group-item" style={{ padding: '20px 0' }}>
      <div className={`row mb-4 m-0 ${isFirstPost ? 'mt-4' : ''}`}>
        <div className="col-lg-3 text-center d-none d-lg-block up-hover">
          <CompanyLink relatedLinks={related_links}>
            <div>
              <CompanyLogo url={thumbnail} />
              <br />
              <h6 style={{ fontWeight: 300, fontSize: 16 }}>{company_name}</h6>
            </div>
          </CompanyLink>
        </div>
        <div className="col-sm-8 col-lg-9">
          <h4
            className="mb-2 color-green clickable-green"
            onClick={() => onSelectJobTitle(jobPosting)}
          >
            {title}
          </h4>
          <JobTags location={location} detectedExtensions={detected_extensions} />
          <div className="d-flex">
            <div
              className="btn btn-outline-primary px-2 mr-2"
              onClick={e => {
                e.preventDefault()
                onSave(jobPosting)
              }}
            >
              <i className="fal fa-save" />
              <span style={{ marginLeft: '4px' }}>Save</span>
            </div>
            <Link
              className="btn btn-outline-primary px-2 mr-2"
              to={searches.buildUrlForSavedEducationSearch({
                searchParams: {
                  searchType: 'career',
                  search_query: encodeURIComponent(
                    title
                      .replace(/\(.*\)/, '') // remove content in parents
                      .replace(/\//g, ' ')
                      .replace(/[^a-zA-Z0-9 ]/g, '') // remove all non alphanumerics other than spaces
                      .replace(/ +/g, ' ') // remove repeated spaces
                      .trim(),
                  ),
                },
              })}
            >
              {' '}
              <Insight
                content="Click here to search job titles that interest you."
                willShow={index === 0}
              >
                <Tooltip
                  title="Click here to search this job title."
                  sticky
                  arrow
                  position="top-end"
                  trigger="mouseenter focus"
                >
                  <i className="fal fa-search" /> Analyze this Title
                </Tooltip>
              </Insight>
            </Link>
          </div>
        </div>
      </div>
      {!isLastPost && <div className="dropdown-divider" />}
    </div>
  )
}

export default withErrorBoundaryReturnNull(JobPostingListItem)



// WEBPACK FOOTER //
// ./src/routes/authenticated/JobSearch/components/JobPostingListItem.js